import React, { useContext } from 'react';
import './Gallery.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/servicePage/gallery/1.png';
import imgTwo from '../../assets/servicePage/gallery/2.png';
import imgThree from '../../assets/servicePage/gallery/3.png';
import imgFour from '../../assets/servicePage/gallery/4.png';
import imgFive from '../../assets/servicePage/gallery/5.png';
import imgSix from '../../assets/servicePage/gallery/6.png';
import { LanguageContext } from '../../context/LanguageContext';
import OptimizedImage from '../../components/OptimizedImage';

const Gallery = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className='gallery-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle={t('gallery.sectionTitle')}
                    title={t('gallery.title')}
                    description={t('gallery.description')}
                />
                <div className="row">
                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgOne} alt={t('altText.gallery')} />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgTwo} alt={t('altText.gallery')} />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgThree} alt={t('altText.gallery')} />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgFour} alt={t('altText.gallery')} />
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgFive} alt={t('altText.gallery')} />
                        </div>
                    </div>
                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img">
                            <OptimizedImage src={imgSix} alt={t('altText.gallery')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gallery;